export const skills = [
    "React",
    "TypeScript",
    "JavaScript",
    "CSS",
    "Jest",
    "PostgreSQL",
    "Playwright",
    "Three JS",
    "Next.js",
    "Tailwind",
    "C++",
    "Git",
];

export const imageSrc = [
    "/aboutme_assets/reactIcon_large.svg",
    "/aboutme_assets/typescript_Icon.svg",
    "/aboutme_assets/logo-javascript.svg",
    "/aboutme_assets/css-3.svg",
    "/aboutme_assets/jest.svg",
    "/aboutme_assets/postgres_Icon.svg",
    "/aboutme_assets/playwright.svg",
    "/aboutme_assets/threejs-1.svg",
    "/aboutme_assets/nextjs.svg",
    "/aboutme_assets/tailwind.svg",
    "/aboutme_assets/c.svg",
    "/aboutme_assets/git.svg",
];

export const imageAlt = [
    "React Icon",
    "TypeScript Icon",
    "JavaScript Icon",
    "CSS Icon",
    "Jest Testing Icon",
    "PostgreSQL Icon",
    "Playwright Testing Icon",
    "Three JS Icon",
    "Next JS Icon",
    "Tailwind CSS Icon",
    "C++ Icon",
    "Git Icon",
];